import React, { createContext, useEffect, useState } from "react";

export const UserContext = createContext();
export const UserProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState(() => {
    const savedUserdetails = localStorage.getItem("userDetails");
    return savedUserdetails !== null ? JSON.parse(savedUserdetails) : "";
  });

  useEffect(() => {
    localStorage.setItem("userDetails", JSON.stringify(userDetails));
  }, [userDetails]);

  return (
    <UserContext.Provider value={{ userDetails, setUserDetails }}>
      {children}
    </UserContext.Provider>
  );
};
